// -----------------------------------------------------------------------------
// 業務運用状態 アクション種別
// -----------------------------------------------------------------------------
export default {
  UPDATE_STATUS: 'RUN_STAT/UPDATE_STATUS',    // 業務運用状態を更新
  CLEAR_COMING: 'RUN_STAT/CLEAR_COMING',      // 近々の運用状態をクリア
};
